import React, { useState } from 'react';
import PropTypes from 'prop-types';
import compose from 'lodash.flowright';
import { withRouter } from 'react-router-dom';

import Button from '../../../../../../../../../components/global/Button';
import CreateWizardLayout from '../../../../../../../components/CreateWizardLayout';

const propTypes = {
  values: PropTypes.object,
  handleChange: PropTypes.func,
  step: PropTypes.shape({
    component: PropTypes.node,
    validate: PropTypes.func,
  }),
  onComplete: PropTypes.func,
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      validate: PropTypes.func,
    }),
  ),
  stepProps: PropTypes.shape({
    setActiveStepIndex: PropTypes.func,
    values: PropTypes.object,
  }),
  setStepProps: PropTypes.func.isRequired,
};

const FreemiumEventCreateReviewStepUpdate = ({
  values,
  handleChange,
  onComplete,
  step,
  steps,
  stepProps,
  setStepProps,
  // other formik related props:
  ...props
}) => {
  const [localValues, setLocalValues] = useState(values);
  // Errors init empty because in the review step, no errors should appear
  const [localErrors, setLocalErrors] = useState({});
  const [localStepProps, setLocalStepProps] = useState(stepProps);

  const localHandleChange = event => {
    const {
      target: { name, value },
    } = event;

    setLocalValues(currentLocalValues => ({
      ...currentLocalValues,
      [name]: value,
    }));
  };

  if (!step) {
    return null;
  }

  const handleSubmit = event => {
    event.preventDefault();

    const validatedErrors = step.validate ? step.validate(localValues) : {};

    if (Object.keys(validatedErrors).length > 0) {
      setLocalErrors(validatedErrors);
      return;
    }

    // Handle change and so on....
    Object.keys(values).forEach(key => {
      if (localValues[key] !== values[key]) {
        handleChange({
          target: {
            name: key,
            value: localValues[key],
          },
        });
      }
    });

    setStepProps({
      ...stepProps,
      values: localValues,
    });

    onComplete?.();
  };

  const StepComponent = step.component;

  return (
    <CreateWizardLayout.Wrapper>
      <CreateWizardLayout.Content>
        <StepComponent
          {...props}
          values={localValues}
          handleChange={localHandleChange}
          errors={localErrors}
          // We will mark everything as touched so we can display any errors.
          // Because we're in the review step, in theory, this is true.
          touched={Object.keys(values).reduce(
            (obj, key) => ({ ...obj, [key]: true }),
            {},
          )}
          stepProps={localStepProps}
          setStepProps={setLocalStepProps}
        />

        <div className="text-right">
          <Button
            className="text-extra-bold px-5 mt-2"
            data-testid="album-create-wizard-create-btn"
            onClick={handleSubmit}
          >
            Update
          </Button>
        </div>
      </CreateWizardLayout.Content>
    </CreateWizardLayout.Wrapper>
  );
};

FreemiumEventCreateReviewStepUpdate.propTypes = propTypes;

export default compose(withRouter)(FreemiumEventCreateReviewStepUpdate);
